import {WidgetData} from '../../../core/shared/widget/widget-data';
import {WidgetFactory} from '../../../core/shared/widget/service/widget.factory';
import {FilterCriteria} from '../../../core/shared/filter/api/filter.criteria';
import {Sorting} from '../../../core/shared/misc/sorting';
import {
    WidgetFunctionCallBackCreate,
    WidgetToolbarCreateInterface
} from '../../../core/shared/helper/widget-function-call-back-create';

/**
 * Alias of the "Tickettypen" child widget of a request type (CONFIG-011: exactly ONE alias across
 * every state of the widget).
 */
export const CW_REQUEST_TYPE_TICKET_TYPE_WIDGET_ALIAS = 'config.cw.CwRequestTypeTicketType.widget';

/**
 * Builds the "Tickettypen" child table of one {@code cw.CwRequestType} (T3 FE-09) — the ticket
 * kinds the back office may raise from an intake of that type.
 *
 * Each row also carries the two tm object roles the request and the customer are linked into;
 * leaving them empty produces a ticket without its object links, which reads as "the ticket lost
 * its context" rather than as a configuration gap.
 *
 * TRAP CONFIG-012: the parent FK is pre-set on CREATE via {@code onFunctionCreateNew}.
 *
 * @param requestTypeId id of the selected parent {@code cw.CwRequestType}.
 */
export function buildCwRequestTypeTicketTypeWidget(requestTypeId: number): WidgetData {
    /**
     * AI:
     * Status: "in progress"
     * Type: Widget
     * SubType: Runtime
     * Reason: Child table of one CwRequestType's Tickettypen, parent FK pre-set on CREATE via
     *   WidgetFunctionCallBackCreate (CONFIG-012).
     */
    const widgetData = WidgetFactory.createWidgetTableEntityFkeyResolveQl(
        CW_REQUEST_TYPE_TICKET_TYPE_WIDGET_ALIAS,
        'Tickettypen',
        'cw.CwRequestTypeTicketType',
        [FilterCriteria.create('e.requestTypeId', FilterCriteria.cOperatorEqual, requestTypeId)],
        [new Sorting('e.sortOrder', true)]
    );
    widgetData.noDataText = 'Keine Tickettypen für diesen Antragstyp konfiguriert';

    const fields: WidgetToolbarCreateInterface[] = [{fieldName: 'requestTypeDtoId', fieldValue: requestTypeId}];
    widgetData.functionCallbacks = WidgetFunctionCallBackCreate.widgetToolbarCreate(fields);

    return widgetData;
}
